import React from 'react'
import { CSSTransition } from 'react-transition-group'

export default function Modal({ show, setModal, sm, lg, style, className, title, warning, hdrActn, children, subTitle }) {
  const handleClickOutside = e => {
    if (e.target.classList.contains('btcd-modal-wrp')) {
      setModal(false)
    }
  }


  return (
    <CSSTransition
      in={show}
      timeout={500}
      classNames="btc-mdl-trn"
      unmountOnExit
    >
      <div
        role="button"
        tabIndex={0}
        onKeyPress={handleClickOutside}
        onClick={handleClickOutside}
        className="btcd-modal-wrp flx"
      >
        <div
          className={`btcd-modal ${sm ? 'btcd-m-sm' : ''} ${lg ? 'btcd-m-lg' : ''} ${className}`}
          style={style}
        >
          <div className="btcd-modal-content">
            {hdrActn}
            <button onClick={() => setModal(false)} className="icn-btn btcd-mdl-close" aria-label="modal-close" type="button"><CloseIcn size={16} stroke={3} /></button>
            <h2 className="btcd-mdl-title flx" style={{ color: warning ? 'red' : '' }}>{title}</h2>
            <small className="btcd-mdl-subtitle">{subTitle}</small>
            {!sm && <div className="btcd-mdl-div" />}
            {children}
          </div>
        </div>
      </div>
    </CSSTransition>
  )
}

const CloseIcn = ({ size, stroke = 4, className })=> {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} width={size} height={size} viewBox="0 0 30 30">
      <line className="svg-icn" strokeWidth={stroke} x1="4" y1="3.88" x2="26" y2="26.12" />
      <line className="svg-icn" strokeWidth={stroke} x1="26" y1="3.88" x2="4" y2="26.12" />
    </svg>
  )
}